import type { SvgIconProps } from '@axieinfinity/matcha-icons'

import type { SocialNetworkAccount } from '~/apis'
import type { TConnectProps } from '~/components/Socials/Connect'

export type TSocialAccount = {
  name: string
  Icon: React.FC<SvgIconProps>
  profile?: SocialNetworkAccount
  altName?: string
  Component: React.FC<TConnectProps>
}

export const SocialAccount: React.FC<TSocialAccount> = props => {
  // const { user } = useAuthContext()
  const { name, Icon, profile, altName, Component } = props
  const isConnected = !!profile
  // const isLastAccount = isConnected && user?.socialAccounts?.length === 1

  return (
    <div className="flex justify-between gap-12">
      <div className="flex items-center gap-12 w-2/3 sm:w-auto">
        <div className="p-4 rounded-circle border border-border-color-secondary-disabled">
          <Icon />
        </div>
        <span className="text-body-m-strong truncate">
          {isConnected ? profile.email || profile.name : altName ?? name}
        </span>
      </div>
      <div className="flex items-center justify-end">
        {!isConnected && <Component connected={isConnected} />}
        {/* {isConnected ? (
          <Tooltip
            id={name}
            target={<Component disabled connected={isConnected} />}
          >
            This feature is temporarily not available for now
          </Tooltip>
        ) : (
          <Component connected={isConnected} />
        )} */}
      </div>
    </div>
  )
}
